import styled, { CSSObject } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// types
import { ICON_CLASS } from "./constants";
import { ApplyCouponPotentialCommsType } from "@swiggy-private/cart-types";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const extendStyledBasedOnType = (theme: ITheme, type: ApplyCouponPotentialCommsType): CSSObject => {
    switch (type) {
        case ApplyCouponPotentialCommsType.IPL_SWIGGY_SIXES: {
            return {
                clipPath: "polygon(22px 0,100% 0,100% 100%,0 100%)",
                padding: `${theme.spacing.xSmall} ${theme.spacing.large} ${theme.spacing.xSmall} ${theme.spacing.xLarge}`,
                borderTopRightRadius: theme.cornerRadius.large,
                borderBottomRightRadius: theme.cornerRadius.large,
            };
        }
        case ApplyCouponPotentialCommsType.FTUE: {
            return {
                zIndex: 2,
            };
        }
        default:
            return {};
    }
};

const extendIconStylesBasedOnType = (theme: ITheme, type: ApplyCouponPotentialCommsType): CSSObject => {
    switch (type) {
        case ApplyCouponPotentialCommsType.IPL_SWIGGY_SIXES: {
            return {
                position: "relative",
                right: "-81%",
                paddingRight: theme.spacing.xxxSmall,
            };
        }
        case ApplyCouponPotentialCommsType.FTUE: {
            return {
                display: "flex",
            };
        }
        default:
            return {};
    }
};

const extendContainerStylesBasedOnType = (theme: ITheme, type: ApplyCouponPotentialCommsType): CSSObject => {
    switch (type) {
        case ApplyCouponPotentialCommsType.FTUE: {
            return {
                backgroundColor: theme.colors[theme.colorMode].background_inverse_Primary,
                borderRadius: theme.cornerRadius.medium,
                justifyContent: "space-between",
                width: "100%",
                gap: theme.spacing.xxSmall,
                padding: `${theme.spacing.xSmall} ${theme.spacing.xSmall} ${theme.spacing.xSmall} ${theme.spacing.xSmall}`,
                marginTop: theme.spacing.small,
                position: "relative",
            };
        }
        default:
            return {};
    }
};

export const Wrapper = styled.div(() => {
    return {
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
    };
});

export const Container = styled.div<{ type?: ApplyCouponPotentialCommsType }>(
    ({ theme, type = ApplyCouponPotentialCommsType.INVALID }) => {
        return {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: theme.spacing.xSmall,
            flexDirection: "row-reverse",
            ...extendContainerStylesBasedOnType(theme, type),
        };
    },
);

export const TextContainer = styled(Text)<{
    textColor?: string;
    bgColor: string;
    type?: ApplyCouponPotentialCommsType;
}>(({ bgColor, textColor, theme, type = ApplyCouponPotentialCommsType.INVALID }) => {
    return {
        background: bgColor || theme.colors[theme.colorMode].background_Primary,
        color: textColor || theme.colors[theme.colorMode].text_Highest_Emphasis,
        ...extendStyledBasedOnType(theme, type),
    };
});

export const IconContainer = styled.div<{ type?: ApplyCouponPotentialCommsType }>(
    ({ theme, type = ApplyCouponPotentialCommsType.INVALID }) => {
        return {
            [`.${ICON_CLASS}`]: extendIconStylesBasedOnType(theme, type),
        };
    },
);

export const TipArrow = styled.div(({ theme }) => {
    return {
        position: "absolute",
        top: 0,
        left: "30%",
        width: theme.spacing.xLarge,
        height: theme.spacing.xLarge,
        background: theme.colors[theme.colorMode].background_inverse_Primary,
        transform: "rotate(-60deg) skew(-30deg)",
        boxShadow: "0px 1px 16px rgba(2, 6, 12, 0.08)",
        zIndex: "1",
        borderRadius: theme.cornerRadius.xxSmall,
    };
});

export const CloseIconWrapper = styled.div(() => {
    return {
        transform: `translate(0, 2px)`,
        marginLeft: "auto",
        order: -1,
    };
});
